// @ts-nocheck
import * as Types from '../../../../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { AssetInfoFragmentDoc } from '../../../../../../assets/AssetPreview.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ChooseReplacementPossibleMaterialsQueryVariables = Types.Exact<{
  filter: Types.MaterialVariantsForPlaceholderFilter;
  orderBy?: Types.InputMaybe<Types.MaterialVariantOrderBy>;
}>;


export type ChooseReplacementPossibleMaterialsQuery = { __typename?: 'Query', materialVariantsForPlaceholder: Array<{ __typename?: 'MaterialVariant', id: string, displayName: string, featuredImage?: { __typename?: 'MaterialVariantImage', id: string, asset?: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined } | null | undefined } | null | undefined, listing: { __typename?: 'MaterialListing', id: string, name?: string | null | undefined, brand?: { __typename?: 'MaterialBrand', id: string, name: string } | null | undefined } }> };


export const ChooseReplacementPossibleMaterialsDocument = gql`
    query ChooseReplacementPossibleMaterials($filter: MaterialVariantsForPlaceholderFilter!, $orderBy: MaterialVariantOrderBy) {
  materialVariantsForPlaceholder(filter: $filter, orderBy: $orderBy) {
    id
    displayName
    featuredImage {
      id
      asset {
        ...AssetInfo
      }
    }
    listing {
      id
      name
      brand {
        id
        name
      }
    }
  }
}
    ${AssetInfoFragmentDoc}`;

/**
 * __useChooseReplacementPossibleMaterialsQuery__
 *
 * To run a query within a React component, call `useChooseReplacementPossibleMaterialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useChooseReplacementPossibleMaterialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChooseReplacementPossibleMaterialsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useChooseReplacementPossibleMaterialsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ChooseReplacementPossibleMaterialsQuery, ChooseReplacementPossibleMaterialsQueryVariables> & ({ variables: ChooseReplacementPossibleMaterialsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ChooseReplacementPossibleMaterialsQuery, ChooseReplacementPossibleMaterialsQueryVariables>(ChooseReplacementPossibleMaterialsDocument, options);
      }
export function useChooseReplacementPossibleMaterialsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ChooseReplacementPossibleMaterialsQuery, ChooseReplacementPossibleMaterialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ChooseReplacementPossibleMaterialsQuery, ChooseReplacementPossibleMaterialsQueryVariables>(ChooseReplacementPossibleMaterialsDocument, options);
        }
// @ts-ignore
export function useChooseReplacementPossibleMaterialsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ChooseReplacementPossibleMaterialsQuery, ChooseReplacementPossibleMaterialsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ChooseReplacementPossibleMaterialsQuery, ChooseReplacementPossibleMaterialsQueryVariables>;
export function useChooseReplacementPossibleMaterialsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ChooseReplacementPossibleMaterialsQuery, ChooseReplacementPossibleMaterialsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ChooseReplacementPossibleMaterialsQuery | undefined, ChooseReplacementPossibleMaterialsQueryVariables>;
export function useChooseReplacementPossibleMaterialsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ChooseReplacementPossibleMaterialsQuery, ChooseReplacementPossibleMaterialsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ChooseReplacementPossibleMaterialsQuery, ChooseReplacementPossibleMaterialsQueryVariables>(ChooseReplacementPossibleMaterialsDocument, options);
        }
export type ChooseReplacementPossibleMaterialsQueryHookResult = ReturnType<typeof useChooseReplacementPossibleMaterialsQuery>;
export type ChooseReplacementPossibleMaterialsLazyQueryHookResult = ReturnType<typeof useChooseReplacementPossibleMaterialsLazyQuery>;
export type ChooseReplacementPossibleMaterialsSuspenseQueryHookResult = ReturnType<typeof useChooseReplacementPossibleMaterialsSuspenseQuery>;
export type ChooseReplacementPossibleMaterialsQueryResult = ApolloReactCommon.QueryResult<ChooseReplacementPossibleMaterialsQuery, ChooseReplacementPossibleMaterialsQueryVariables>;